export default __webpack_public_path__ + "static/media/button-finish.6f1ee2dc.png";